import { render, staticRenderFns } from "./FlightSummary.vue?vue&type=template&id=e18f2b08"
import script from "./FlightSummary.vue?vue&type=script&lang=js"
export * from "./FlightSummary.vue?vue&type=script&lang=js"
import style0 from "./FlightSummary.vue?vue&type=style&index=0&id=e18f2b08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports